export default "__VITE_ASSET__BDx$ES32__"